var nb = require('./nb');
var $ = nb.opts.$;
var list =[];
var id = 1;
var imgId = 9;
for(var i=1;i<=4;i++){
    list.push({
        id:imgId,
        name:'梳妆台'+id,
        engName:"shuangxhuangtai",
        price:1000,
        frontImg:'./image/mockup/product/'+imgId+'.jpg',
        backImg:'./image/mockup/product/'+imgId+'-2.jpg'
    });
    id++;
    imgId++;
}
var map={
    1:{
        id:1,
        lowProdId:10,
        frontImg: './image/mockup/product/1.jpg',
        backImg: './image/mockup/product/1.jpg',
        series: 'wlsb',
        name: '威廉斯堡梳妆台',
        engName: 'Williamsburg Dresser',
        price: 299000,
        like: 0,
        detail:{
            productId:1,
            name:'威廉斯堡梳妆台',
            engName:'dian shi gui',
            desc:'抽屉带有一体式轻柔关闭功能，可轻柔无声地关闭。' +
            ' 强化玻璃顶板可保护顶层搁板，并令其呈现不同的外观。' +
            ' 该支腿将抬高，为家具平添宽敞明亮的气息，也方便你清扫地板',
            classic:'威廉斯堡',
            itemNo:'15555-5001',
            sizeList:[{
                itemNo:'15555-5001',
                size:'200*200*200',
                price:2000,
                skuId:10,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/1.jpg'
                ],
                stock:100,
                sales:50
            },{
                itemNo:'15555-5001',
                size:'300*300*300',
                skuId:11,
                price:2100,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/1.jpg'
                ],
                stock:100,
                sales:51
            },{
                itemNo:'15555-5001',
                size:'400*400*400',
                price:2200,
                skuId:12,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/1.jpg'
                ],
                stock:100,
                sales:52
            }]
        },
        recommendList:list,
        commentList:[{
            "id": 1,//用户id
            "nickname": "jun",//用户昵称
            "score": 9.5,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "这段时间忙着工作，一直没发评论 ，" +
            "安装起来比较简约，各方面也还可以（例如：五金件，" +
            "材料稳重性），收到后这个凳子底部是刮伤怎样，" +
            "我不明白，其实第一时间是想退，后来想想也算了，" +
            "因为平时没什么时间收快递，希望店家以后多检查东西",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 2,//用户id
            "nickname": "黄小姐",//用户昵称
            "score": 9.1,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 3,//用户id
            "nickname": "王先生",//用户昵称
            "score": 9.0,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 4,//用户id
            "nickname": "王小姐",//用户昵称
            "score": 7.3,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/9.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 5,//用户id
            "nickname": "刘先生",//用户昵称
            "score": 8.6,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/9.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        }]
    },
    2:{
        id:2,
        lowProdId:20,
        frontImg: './image/mockup/product/2.jpg',
        backImg: './image/mockup/product/2.jpg',
        series: 'wlsb',
        name: '床头几',
        engName: 'Williamsburg Dresser',
        price: 299000,
        like: 0,
        detail:{
            productId:2,
            name:'床头几',
            engName:'dian shi gui',
            desc:'抽屉带有一体式轻柔关闭功能，可轻柔无声地关闭。' +
            ' 强化玻璃顶板可保护顶层搁板，并令其呈现不同的外观。' +
            ' 该支腿将抬高，为家具平添宽敞明亮的气息，也方便你清扫地板',
            itemNo:'15555-5001',
            classic:'银湖',
            sizeList:[{
                itemNo:'15555-5001',
                size:'200*200*200',
                price:2000,
                skuId:20,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/2.jpg'
                ],
                stock:100,
                sales:50
            },{
                itemNo:'15555-5001',
                size:'300*300*300',
                price:2700,
                skuId:21,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/2.jpg'
                ],
                stock:100,
                sales:51
            },{
                itemNo:'15555-5001',
                size:'400*400*400',
                price:2400,
                skuId:22,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/2.jpg'
                ],
                stock:100,
                sales:52
            }]
        },
        recommendList:list,
        commentList:[{
            "id": 1,//用户id
            "nickname": "jun",//用户昵称
            "score": 9.5,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "这段时间忙着工作，一直没发评论 ，" +
            "安装起来比较简约，各方面也还可以（例如：五金件，" +
            "材料稳重性），收到后这个凳子底部是刮伤怎样，" +
            "我不明白，其实第一时间是想退，后来想想也算了，" +
            "因为平时没什么时间收快递，希望店家以后多检查东西",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 2,//用户id
            "nickname": "黄小姐",//用户昵称
            "score": 9.1,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 3,//用户id
            "nickname": "王先生",//用户昵称
            "score": 9.0,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 4,//用户id
            "nickname": "王小姐",//用户昵称
            "score": 7.3,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/9.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 5,//用户id
            "nickname": "刘先生",//用户昵称
            "score": 8.6,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/9.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        }]
    },
    3:{
        id:3,
        lowProdId:30,
        frontImg: './image/mockup/product/3.jpg',
        backImg: './image/mockup/product/3.jpg',
        series: 'wlsb',
        name: '立柜 ',
        engName: 'Williamsburg Dresser',
        price: 299000,
        like: 0,
        detail:{
            productId:3,
            name:'立柜',
            engName:'dian shi gui',
            desc:'抽屉带有一体式轻柔关闭功能，可轻柔无声地关闭。' +
            ' 强化玻璃顶板可保护顶层搁板，并令其呈现不同的外观。' +
            ' 该支腿将抬高，为家具平添宽敞明亮的气息，也方便你清扫地板',
            itemNo:'15555-5001',
            classic:'银湖',
            sizeList:[{
                itemNo:'15555-5001',
                size:'200*200*200',
                price:2000,
                skuId:30,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/3.jpg'
                ],
                stock:100,
                sales:50
            },{
                itemNo:'15555-5001',
                size:'300*300*300',
                price:2600,
                skuId:31,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/3.jpg'
                ],
                stock:100,
                sales:51
            },{
                itemNo:'15555-5001',
                size:'400*400*400',
                price:2200,
                disPrice:1900,
                skuId:32,
                imgList:[
                    './image/mockup/product/3.jpg'
                ],
                stock:100,
                sales:52
            }]
        },
        recommendList:list,
        commentList:[{
            "id": 1,//用户id
            "nickname": "jun",//用户昵称
            "score": 9.5,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "这段时间忙着工作，一直没发评论 ，" +
            "安装起来比较简约，各方面也还可以（例如：五金件，" +
            "材料稳重性），收到后这个凳子底部是刮伤怎样，" +
            "我不明白，其实第一时间是想退，后来想想也算了，" +
            "因为平时没什么时间收快递，希望店家以后多检查东西",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 2,//用户id
            "nickname": "黄小姐",//用户昵称
            "score": 9.1,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 3,//用户id
            "nickname": "王先生",//用户昵称
            "score": 9.0,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 4,//用户id
            "nickname": "王小姐",//用户昵称
            "score": 7.3,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/9.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 5,//用户id
            "nickname": "刘先生",//用户昵称
            "score": 8.6,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/9.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        }]
    },
    4:{
        id:4,
        lowProdId:40,
        frontImg: './image/mockup/product/4.jpg',
        backImg: './image/mockup/product/4.jpg',
        series: 'wlsb',
        name: '长凳 ' ,
        engName: 'Williamsburg Dresser',
        price: 299000,
        like: 0,
        detail:{
            productId:4,
            name:'长凳',
            engName:'chang deng',
            desc:'抽屉带有一体式轻柔关闭功能，可轻柔无声地关闭。' +
            ' 强化玻璃顶板可保护顶层搁板，并令其呈现不同的外观。' +
            ' 该支腿将抬高，为家具平添宽敞明亮的气息，也方便你清扫地板',
            itemNo:'15555-5001',
            classic:'银湖',
            sizeList:[{
                itemNo:'15555-5001',
                size:'200*200*200',
                price:2000,
                disPrice:1900,
                skuId:40,
                imgList:[
                    './image/mockup/product/4.jpg'
                ],
                stock:100,
                sales:50
            },{
                itemNo:'15555-5001',
                size:'300*300*300',
                price:2100,
                skuId:41,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/4.jpg'
                ],
                stock:100,
                sales:51
            },{
                itemNo:'15555-5001',
                size:'400*400*400',
                price:2200,
                skuId:42,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/4.jpg'
                ],
                stock:100,
                sales:52
            }]
        },
        recommendList:list,
        commentList:[{
            "id": 1,//用户id
            "nickname": "jun",//用户昵称
            "score": 9.5,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "这段时间忙着工作，一直没发评论 ，" +
            "安装起来比较简约，各方面也还可以（例如：五金件，" +
            "材料稳重性），收到后这个凳子底部是刮伤怎样，" +
            "我不明白，其实第一时间是想退，后来想想也算了，" +
            "因为平时没什么时间收快递，希望店家以后多检查东西",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 2,//用户id
            "nickname": "黄小姐",//用户昵称
            "score": 9.1,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 3,//用户id
            "nickname": "王先生",//用户昵称
            "score": 9.0,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 4,//用户id
            "nickname": "王小姐",//用户昵称
            "score": 7.3,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/9.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 5,//用户id
            "nickname": "刘先生",//用户昵称
            "score": 8.6,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/9.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        }]
    },
    5:{
        id:5,
        lowProdId:50,
        frontImg: './image/mockup/product/5.jpg',
        backImg: './image/mockup/product/5.jpg',
        series: 'wlsb',
        name: '立柜 ',
        engName: 'Williamsburg Dresser',
        price: 299000,
        like: 0,
        detail:{
            productId:5,
            name:'立柜',
            engName:'li gui',
            desc:'抽屉带有一体式轻柔关闭功能，可轻柔无声地关闭。' +
            ' 强化玻璃顶板可保护顶层搁板，并令其呈现不同的外观。' +
            ' 该支腿将抬高，为家具平添宽敞明亮的气息，也方便你清扫地板',
            itemNo:'15555-5001',
            classic:'银湖',
            sizeList:[{
                itemNo:'15555-5001',
                size:'200*200*200',
                price:2000,
                skuId:50,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/5.jpg'
                ],
                stock:100,
                sales:50
            },{
                itemNo:'15555-5001',
                size:'300*300*300',
                price:2100,
                disPrice:1900,
                skuId:51,
                imgList:[
                    './image/mockup/product/5.jpg'
                ],
                stock:100,
                sales:51
            },{
                itemNo:'15555-5001',
                size:'400*400*400',
                price:2200,
                skuId:52,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/5.jpg'
                ],
                stock:100,
                sales:52
            }]
        },
        recommendList:list,
        commentList:[{
            "id": 1,//用户id
            "nickname": "jun",//用户昵称
            "score": 9.5,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "这段时间忙着工作，一直没发评论 ，" +
            "安装起来比较简约，各方面也还可以（例如：五金件，" +
            "材料稳重性），收到后这个凳子底部是刮伤怎样，" +
            "我不明白，其实第一时间是想退，后来想想也算了，" +
            "因为平时没什么时间收快递，希望店家以后多检查东西",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 2,//用户id
            "nickname": "黄小姐",//用户昵称
            "score": 9.1,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 3,//用户id
            "nickname": "王先生",//用户昵称
            "score": 9.0,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 4,//用户id
            "nickname": "王小姐",//用户昵称
            "score": 7.3,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/9.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 5,//用户id
            "nickname": "刘先生",//用户昵称
            "score": 8.6,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/9.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        }]
    },
    6:{
        id:6,
        lowProdId:60,
        frontImg:'./image/mockup/product/6.jpg',
        backImg: './image/mockup/product/6.jpg',
        series: 'wlsb',
        name: '电视柜 ',
        engName: 'Williamsburg Dresser',
        price: 299000,
        like: 0,
        detail:{
            productId:6,
            name:'电视柜',
            engName:'dian shi gui',
            desc:'抽屉带有一体式轻柔关闭功能，可轻柔无声地关闭。' +
            ' 强化玻璃顶板可保护顶层搁板，并令其呈现不同的外观。' +
            ' 该支腿将抬高，为家具平添宽敞明亮的气息，也方便你清扫地板',
            itemNo:'15555-5001',
            classic:'银湖',
            sizeList:[{
                itemNo:'15555-5001',
                size:'200*200*200',
                price:2000,
                disPrice:1900,
                skuId:60,
                imgList:[
                    './image/mockup/product/6.jpg'
                ],
                stock:100,
                sales:50
            },{
                itemNo:'15555-5001',
                size:'300*300*300',
                price:2100,
                disPrice:1900,
                skuId:61,
                imgList:[
                    './image/mockup/product/6.jpg'
                ],
                stock:100,
                sales:51
            },{
                itemNo:'15555-5001',
                size:'400*400*400',
                price:2200,
                disPrice:1900,
                skuId:62,
                imgList:[
                    './image/mockup/product/6.jpg'
                ],
                stock:100,
                sales:52
            }]
        },
        recommendList:list,
        commentList:[{
            "id": 1,//用户id
            "nickname": "jun",//用户昵称
            "score": 9.5,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "这段时间忙着工作，一直没发评论 ，" +
            "安装起来比较简约，各方面也还可以（例如：五金件，" +
            "材料稳重性），收到后这个凳子底部是刮伤怎样，" +
            "我不明白，其实第一时间是想退，后来想想也算了，" +
            "因为平时没什么时间收快递，希望店家以后多检查东西",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 2,//用户id
            "nickname": "黄小姐",//用户昵称
            "score": 9.1,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 3,//用户id
            "nickname": "王先生",//用户昵称
            "score": 9.0,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 4,//用户id
            "nickname": "王小姐",//用户昵称
            "score": 7.3,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/9.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 5,//用户id
            "nickname": "刘先生",//用户昵称
            "score": 8.6,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/9.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        }]
    },
    7:{
        id:7,
        lowProdId:70,
        frontImg: './image/mockup/product/7.jpg',
        backImg: './image/mockup/product/7.jpg',
        series: 'wlsb',
        name: '圆凳 ',
        engName: 'Williamsburg Dresser',
        price: 299000,
        like: 0,
        detail:{
            productId:7,
            name:'圆凳',
            engName:'yuan deng',
            desc:'抽屉带有一体式轻柔关闭功能，可轻柔无声地关闭。' +
            ' 强化玻璃顶板可保护顶层搁板，并令其呈现不同的外观。' +
            ' 该支腿将抬高，为家具平添宽敞明亮的气息，也方便你清扫地板',
            itemNo:'15555-5001',
            classic:'银湖',
            sizeList:[{
                itemNo:'15555-5001',
                size:'200*200*200',
                price:2000,
                disPrice:1900,
                skuId:70,
                imgList:[
                    './image/mockup/product/7.jpg'
                ],
                stock:100,
                sales:50
            },{
                itemNo:'15555-5001',
                size:'300*300*300',
                price:2100,
                skuId:71,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/7.jpg'
                ],
                stock:100,
                sales:51
            },{
                itemNo:'15555-5001',
                size:'400*400*400',
                price:2200,
                skuId:72,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/7.jpg'
                ],
                stock:100,
                sales:52
            }]
        },
        recommendList:list,
        commentList:[{
            "id": 1,//用户id
            "nickname": "jun",//用户昵称
            "score": 9.5,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "这段时间忙着工作，一直没发评论 ，" +
            "安装起来比较简约，各方面也还可以（例如：五金件，" +
            "材料稳重性），收到后这个凳子底部是刮伤怎样，" +
            "我不明白，其实第一时间是想退，后来想想也算了，" +
            "因为平时没什么时间收快递，希望店家以后多检查东西",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 2,//用户id
            "nickname": "黄小姐",//用户昵称
            "score": 9.1,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 3,//用户id
            "nickname": "王先生",//用户昵称
            "score": 9.0,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 4,//用户id
            "nickname": "王小姐",//用户昵称
            "score": 7.3,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/9.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 5,//用户id
            "nickname": "刘先生",//用户昵称
            "score": 8.6,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/9.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        }]
    },
    8:{
        id:8,
        lowProdId:80,
        frontImg: './image/mockup/product/8.jpg',
        backImg: './image/mockup/product/8.jpg',
        series: 'wlsb',
        name: '圆凳 ' ,
        engName: 'Williamsburg Dresser',
        price: 299000,
        like: 0,
        detail:{
            productId:8,
            name:'圆凳',
            engName:'dian shi gui',
            desc:'抽屉带有一体式轻柔关闭功能，可轻柔无声地关闭。' +
            ' 强化玻璃顶板可保护顶层搁板，并令其呈现不同的外观。' +
            ' 该支腿将抬高，为家具平添宽敞明亮的气息，也方便你清扫地板',
            itemNo:'15555-5001',
            classic:'银湖',
            sizeList:[{
                itemNo:'15555-5001',
                size:'200*200*200',
                price:2000,
                skuId:80,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/8.jpg'
                ],
                stock:100,
                sales:50
            },{
                itemNo:'15555-5001',
                size:'300*300*300',
                price:2100,
                disPrice:1900,
                skuId:81,
                imgList:[
                    './image/mockup/product/8.jpg'
                ],
                stock:100,
                sales:51
            },{
                itemNo:'15555-5001',
                size:'400*400*400',
                price:2200,
                disPrice:1900,
                skuId:82,
                imgList:[
                    './image/mockup/product/8.jpg'
                ],
                stock:100,
                sales:52
            }]
        },
        recommendList:list,
        commentList:[{
            "id": 1,//用户id
            "nickname": "jun",//用户昵称
            "score": 9.5,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "这段时间忙着工作，一直没发评论 ，" +
            "安装起来比较简约，各方面也还可以（例如：五金件，" +
            "材料稳重性），收到后这个凳子底部是刮伤怎样，" +
            "我不明白，其实第一时间是想退，后来想想也算了，" +
            "因为平时没什么时间收快递，希望店家以后多检查东西",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 2,//用户id
            "nickname": "黄小姐",//用户昵称
            "score": 9.1,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 3,//用户id
            "nickname": "王先生",//用户昵称
            "score": 9.0,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 4,//用户id
            "nickname": "王小姐",//用户昵称
            "score": 7.3,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/9.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 5,//用户id
            "nickname": "刘先生",//用户昵称
            "score": 8.6,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/9.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        }]
    },
    9:{
        id:9,
        lowProdId:90,
        frontImg: './image/mockup/product/9.jpg',
        backImg: './image/mockup/product/9-4.jpg',
        series: 'wlsb',
        name: '床头几',
        engName: 'Williamsburg Dresser',
        price: 299000,
        like: 0,
        detail:{
            productId:9,
            name:'床头几',
            engName:'dian shi gui',
            desc:'抽屉带有一体式轻柔关闭功能，可轻柔无声地关闭。' +
            ' 强化玻璃顶板可保护顶层搁板，并令其呈现不同的外观。' +
            ' 该支腿将抬高，为家具平添宽敞明亮的气息，也方便你清扫地板',
            itemNo:'15555-5001',
            classic:'银湖',
            sizeList:[{
                itemNo:'15555-5001',
                size:'200*200*200',
                price:2000,
                skuId:90,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/9.jpg',
                    './image/mockup/product/9-2.jpg',
                    './image/mockup/product/9-3.jpg',
                    './image/mockup/product/9-4.jpg'
                ],
                stock:100,
                sales:50
            },{
                itemNo:'15555-5001',
                size:'300*300*300',
                price:2100,
                skuId:91,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/9.jpg',
                    './image/mockup/product/9-2.jpg',
                    './image/mockup/product/9-3.jpg',
                    './image/mockup/product/9-4.jpg'
                ],
                stock:100,
                sales:51
            },{
                itemNo:'15555-5001',
                size:'400*400*400',
                price:2200,
                disPrice:1900,
                skuId:92,
                imgList:[
                    './image/mockup/product/9.jpg',
                    './image/mockup/product/9-2.jpg',
                    './image/mockup/product/9-3.jpg',
                    './image/mockup/product/9-4.jpg'
                ],
                stock:100,
                sales:52
            }]
        },
        recommendList:list,
        commentList:[{
            "id": 1,//用户id
            "nickname": "jun",//用户昵称
            "score": 9.5,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "这段时间忙着工作，一直没发评论 ，" +
            "安装起来比较简约，各方面也还可以（例如：五金件，" +
            "材料稳重性），收到后这个凳子底部是刮伤怎样，" +
            "我不明白，其实第一时间是想退，后来想想也算了，" +
            "因为平时没什么时间收快递，希望店家以后多检查东西",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 2,//用户id
            "nickname": "黄小姐",//用户昵称
            "score": 9.1,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 3,//用户id
            "nickname": "王先生",//用户昵称
            "score": 9.0,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 4,//用户id
            "nickname": "王小姐",//用户昵称
            "score": 7.3,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/9.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 5,//用户id
            "nickname": "刘先生",//用户昵称
            "score": 8.6,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/9.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        }]
    },
    10:{
        id:10,
        lowProdId:100,
        frontImg: './image/mockup/product/10.jpg',
        backImg: './image/mockup/product/10-4.jpg',
        series: 'wlsb',
        name: '斗柜 ' ,
        engName: 'Williamsburg Dresser',
        price: 299000,
        like: 0,
        detail:{
            productId:10,
            name:'斗柜',
            engName:'dou gui',
            desc:'抽屉带有一体式轻柔关闭功能，可轻柔无声地关闭。' +
            ' 强化玻璃顶板可保护顶层搁板，并令其呈现不同的外观。' +
            ' 该支腿将抬高，为家具平添宽敞明亮的气息，也方便你清扫地板',
            itemNo:'15555-5001',
            classic:'银湖',
            sizeList:[{
                itemNo:'15555-5001',
                size:'200*200*200',
                skuId:100,
                price:2000,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/10.jpg',
                    './image/mockup/product/10-2.jpg',
                    './image/mockup/product/10-3.jpg',
                    './image/mockup/product/10-4.jpg'
                ],
                stock:100,
                sales:50
            },{
                itemNo:'15555-5001',
                size:'300*300*300',
                price:2100,
                skuId:101,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/10.jpg',
                    './image/mockup/product/10-2.jpg',
                    './image/mockup/product/10-3.jpg',
                    './image/mockup/product/10-4.jpg'
                ],
                stock:100,
                sales:51
            },{
                itemNo:'15555-5001',
                size:'400*400*400',
                price:2200,
                skuId:102,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/10.jpg',
                    './image/mockup/product/10-2.jpg',
                    './image/mockup/product/10-3.jpg',
                    './image/mockup/product/10-4.jpg'
                ],
                stock:100,
                sales:52
            }]
        },
        recommendList:list,
        commentList:[{
            "id": 1,//用户id
            "nickname": "jun",//用户昵称
            "score": 9.5,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "这段时间忙着工作，一直没发评论 ，" +
            "安装起来比较简约，各方面也还可以（例如：五金件，" +
            "材料稳重性），收到后这个凳子底部是刮伤怎样，" +
            "我不明白，其实第一时间是想退，后来想想也算了，" +
            "因为平时没什么时间收快递，希望店家以后多检查东西",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 2,//用户id
            "nickname": "黄小姐",//用户昵称
            "score": 9.1,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 3,//用户id
            "nickname": "王先生",//用户昵称
            "score": 9.0,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 4,//用户id
            "nickname": "王小姐",//用户昵称
            "score": 7.3,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/9.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 5,//用户id
            "nickname": "刘先生",//用户昵称
            "score": 8.6,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/9.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        }]
    },
    11:{
        id:11,
        lowProdId:110,
        frontImg: './image/mockup/product/11.jpg',
        backImg: './image/mockup/product/11-4.jpg',
        series: 'wlsb',
        name: '立柜 ',
        engName: 'Williamsburg Dresser',
        price: 299000,
        like: 0,
        detail:{
            productId:11,
            name:'立柜',
            engName:'dian shi gui',
            desc:'抽屉带有一体式轻柔关闭功能，可轻柔无声地关闭。' +
            ' 强化玻璃顶板可保护顶层搁板，并令其呈现不同的外观。' +
            ' 该支腿将抬高，为家具平添宽敞明亮的气息，也方便你清扫地板',
            itemNo:'15555-5001',
            classic:'银湖',
            sizeList:[{
                itemNo:'15555-5001',
                size:'200*200*200',
                price:2000,
                skuId:110,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/11.jpg',
                    './image/mockup/product/11-2.jpg',
                    './image/mockup/product/11-3.jpg',
                    './image/mockup/product/11-4.jpg'
                ],
                stock:100,
                sales:50
            },{
                itemNo:'15555-5001',
                size:'300*300*300',
                price:2800,
                disPrice:1900,
                skuId:111,
                imgList:[
                    './image/mockup/product/11.jpg',
                    './image/mockup/product/11-2.jpg',
                    './image/mockup/product/11-3.jpg',
                    './image/mockup/product/11-4.jpg'
                ],
                stock:100,
                sales:51
            },{
                itemNo:'15555-5001',
                size:'400*400*400',
                price:2600,
                skuId:112,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/11.jpg',
                    './image/mockup/product/11-2.jpg',
                    './image/mockup/product/11-3.jpg',
                    './image/mockup/product/11-4.jpg'
                ],
                stock:100,
                sales:52
            }]
        },
        recommendList:list,
        commentList:[{
            "id": 1,//用户id
            "nickname": "jun",//用户昵称
            "score": 9.5,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "这段时间忙着工作，一直没发评论 ，" +
            "安装起来比较简约，各方面也还可以（例如：五金件，" +
            "材料稳重性），收到后这个凳子底部是刮伤怎样，" +
            "我不明白，其实第一时间是想退，后来想想也算了，" +
            "因为平时没什么时间收快递，希望店家以后多检查东西",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 2,//用户id
            "nickname": "黄小姐",//用户昵称
            "score": 9.1,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 3,//用户id
            "nickname": "王先生",//用户昵称
            "score": 9.0,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 4,//用户id
            "nickname": "王小姐",//用户昵称
            "score": 7.3,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/9.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 5,//用户id
            "nickname": "刘先生",//用户昵称
            "score": 8.6,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/9.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        }]
    },
    12:{
        id:12,
        lowProdId:120,
        frontImg: './image/mockup/product/12.jpg',
        backImg: './image/mockup/detail/12-4.jpg',
        series: 'wlsb',
        name: '单柜 ',
        engName: 'Williamsburg Dresser',
        price: 299000,
        like: 0,
        detail:{
            productId:12,
            name:'单柜',
            engName:'dan gui',
            desc:'抽屉带有一体式轻柔关闭功能，可轻柔无声地关闭。' +
            ' 强化玻璃顶板可保护顶层搁板，并令其呈现不同的外观。' +
            ' 该支腿将抬高，为家具平添宽敞明亮的气息，也方便你清扫地板',
            itemNo:'15555-5001',
            classic:'银湖',
            sizeList:[{
                itemNo:'15555-5001',
                size:'200*200*200',
                price:2000,
                skuId:120,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/12.jpg',
                    './image/mockup/product/12-2.jpg',
                    './image/mockup/product/12-3.jpg',
                    './image/mockup/product/12-4.jpg'
                ],
                stock:100,
                sales:50
            },{
                itemNo:'15555-5001',
                size:'300*300*300',
                price:2000,
                skuId:121,
                disPrice:1900,
                imgList:[
                    './image/mockup/product/12.jpg',
                    './image/mockup/product/12-2.jpg',
                    './image/mockup/product/12-3.jpg',
                    './image/mockup/product/12-4.jpg'
                ],
                stock:100,
                sales:51
            },{
                itemNo:'15555-5001',
                size:'400*400*400',
                price:2000,
                disPrice:1900,
                skuId:122,
                imgList:[
                    './image/mockup/product/12.jpg',
                    './image/mockup/product/12-2.jpg',
                    './image/mockup/product/12-3.jpg',
                    './image/mockup/product/12-4.jpg'
                ],
                stock:100,
                sales:52
            }]
        },
        recommendList:list,
        commentList:[{
            "id": 1,//用户id
            "nickname": "jun",//用户昵称
            "score": 9.5,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "这段时间忙着工作，一直没发评论 ，" +
            "安装起来比较简约，各方面也还可以（例如：五金件，" +
            "材料稳重性），收到后这个凳子底部是刮伤怎样，" +
            "我不明白，其实第一时间是想退，后来想想也算了，" +
            "因为平时没什么时间收快递，希望店家以后多检查东西",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 2,//用户id
            "nickname": "黄小姐",//用户昵称
            "score": 9.1,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 3,//用户id
            "nickname": "王先生",//用户昵称
            "score": 9.0,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 4,//用户id
            "nickname": "王小姐",//用户昵称
            "score": 7.3,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/6.pic.jpg","./image/mockup/comment/9.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        },{
            "id": 5,//用户id
            "nickname": "刘先生",//用户昵称
            "score": 8.6,//评分
            "comTime": 1996555563633,//评论时间
            "title": "性价比高",//评论标题
            "content": "到货迅速。礼拜一买的，礼拜天就到了。" +
            "亲自感受了一下，椅子相当有分量。整个安装过程还算满意，" +
            "家里做五金配件的，所以对安装比较苛刻，但是这个基本ok。" +
            "尤其是里面的配件，保护得非常细致，这一点上的体验非常满意，" +
            "螺丝也有专门的塑封包装，用途也有标明，安装起来就更加方便！" +
            "总的来说，买的还是比较值当的。各位可以看看图片，以作参考。",//评论内容
            "imgList": ["./image/mockup/comment/9.pic.jpg","./image/mockup/comment/7.pic.jpg","./image/mockup/comment/8.pic.jpg"],//评论图片
            "proColor": "黑色"//购买商品颜色
        }]
    }
};
var movieImgItems=[
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/0.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/1.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/2.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/3.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/4.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/5.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/6.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/7.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/8.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/9.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/10.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/11.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/12.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/13.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/14.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/15.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/16.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/17.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/18.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/19.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/20.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/21.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/22.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/23.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/24.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/25.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/26.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/27.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/28.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/29.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/30.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/31.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/32.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/33.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/34.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/35.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/36.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/37.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/38.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/39.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/40.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/41.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/42.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/43.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/44.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/45.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/46.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/47.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/48.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/49.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/50.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/51.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/52.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/53.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/54.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/55.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/56.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/57.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/58.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/59.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/60.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/61.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/62.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/63.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/64.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/65.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/66.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/67.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/68.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/69.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/70.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/71.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/72.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/73.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/74.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/75.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/76.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/77.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/78.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/79.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/80.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/81.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/82.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/83.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/84.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/85.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/86.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/87.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/88.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/89.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/90.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/91.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/92.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/93.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/94.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/95.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/96.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/97.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/98.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/99.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/100.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/101.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/102.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/103.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/104.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/105.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/106.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/107.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/108.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/109.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/110.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/111.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/112.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/113.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/114.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/115.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/116.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/117.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/118.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/119.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/120.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/121.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/122.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/123.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/124.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/125.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/126.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/127.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/128.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/129.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/130.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/131.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/132.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/133.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/134.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/135.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/136.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/137.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/138.jpg'},
    {url: 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/139.jpg'}
];
var productList = [];
$.each(map,function (index,item) {
    productList.push({
        id:item.id,
        lowProdId:item.lowProdId,
        frontImg:item.frontImg,
        backImg: item.backImg,
        series: item.series,
        name:item.name,
        engName: item.engName,
        price: item.price,
        like: item.like
    });
});
module.exports={
    getProductList:function () {
        console.log(productList);
        return {
            page:{
            "total":1,//总页数
            "totalRecord":1,//总记录数
            "size":1,//返回记录数
            "index":1//第几页
        },
            rows:productList
        };
    },
    getProductDetail:function (inId) {
        return map[inId]
    },
    getMovieList:function () {
        var imgList = [];
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        // var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
        var isIE = !!window.ActiveXObject || "ActiveXObject" in window; //判断是否IE浏览器
        var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
        // var isSafari = userAgent.indexOf("Safari") > -1; //判断是否Safari浏览器
        if(isIE || isFF){
            imgList = [];
        }else {
            imgList = movieImgItems
        }
        return imgList;
    }
};



//////////////////
// WEBPACK FOOTER
// ../src/js/data.js
// module id = 163
// module chunks = 1 15